import * as yup from 'yup';

import { MAX_ADDRESS_LENGTH, MAX_COMPANY_NAME_LENGTH, MIN_LENGTH } from '@hero/constants';

const infoSchema = yup.object().shape({
  companyName: yup.string().min(MIN_LENGTH).max(MAX_COMPANY_NAME_LENGTH).required(),
  companyAddress: yup.string().min(MIN_LENGTH).max(MAX_ADDRESS_LENGTH).required(),
  zipCode: yup
    .string()
    .min(5)
    .matches(/^[0-9]{5}/)
    .required(),
  city: yup.string().required(),
  state: yup.object().required()
});

export { infoSchema };
